import React from 'react';
import styles from './header.module.scss';
import { ReactComponent as Logo } from 'img/jll-logo.svg';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { openFullPathInNewTab } from 'utils/paths';

export default function Header() {
  const { t } = useTranslation();
  const onClick = () => {
    openFullPathInNewTab();
  };

  return (
    <header data-testid="Header" className={styles.header}>
      <div className={styles.logo_container}>
        <Logo />
        <div className={styles.separator}></div>
        Needs Assessment
      </div>
      <Button
        data-testid="HeaderCreateNewButton"
        className={styles.create_new_button}
        startIcon={<AddCircleOutlineIcon />}
        size="medium"
        variant="contained"
        onClick={onClick}>
        {t('library.createNew')}
      </Button>
    </header>
  );
}
